/*
 * @Descripttion:
 * @version:
 * @Author: HeYang
 * @Date: 2019-08-07 15:59:45
 * @LastEditors: ChenGuocai
 * @LastEditTime: 2021-03-04 14:36:56
 */
import {isSandbox} from '@/common/utils/tools';
import request from "./request"; // 引入axios的封装方法
// 获取直播间信息
export const getRoomInfo = (params: any) => {
    return request("get", `/v1/live/roominfo/${params.id}`, {});
};

// 获取直播列表
export const getLiveList = (params: any) => {
    return request("get", `/v1/live/listv3`, {});
};

//获取单个直播间信息
export const getLiveMess = (params: any) => {
    return request("get", `/v1/live/roominfo/${params.id}`, {});
};

// 获取排麦列表
export const getWheatList = (params: object) => {
    return request("get", "/v1/live/room/user/wheatlist", params);
};

// 获取贡献榜
export const getRewardList = (params: object) => {
    return request("get", "/v1/live/reward/list", params);
};

// 获取即构登录token
export const getZegoLoginToken = (params: object = {}) => {
    return request("get", "/v1/live/zego/getToken", params);
};

// 获取IM游客用户登陆UserSig
export const getUserSig = (params: object = {}) => {
    return request("post", "/v1/live/im/visitor/getusersig", params);
};

// 1元新人大礼包领取
export const getNewUserBag = (params: object = {}) => {
    return request("post", "/v1/order/novicegift", params);
};

//老师入驻流程start
export const uploadImage = (params: object = {}, options: object = {}) => {
    //图片上传接口
    return request("post", "/api/ask/upload/image", params, options);
};

export const uploadImageV1 = (params: object = {}, options: object = {}) => {
  //图片上传接口
  return request("post", "/v1/upload/image", params, options);
};

export const delImage = (params: object = {}) => {
    //删除图片
    return request("post", "/api/ask/del/image", params);
};

export const teacherEnterApply = (params: object = {}, options?: {}) => {
    //入驻申请
    return request("post", "/api/teacher/enter_apply", params, options);
};

export const teacherEnterInfo = (params: object = {}, options?: {}) => {
    //获取入驻申请信息
    return request("get", "/api/teacher/enter_info", params, options);
};

export const teacherEnterService = (params: object = {}, options?: {}) => {
    //入驻咨询室列表
    return request("get", "/api/teacher/enter_service", params, options);
};

export const teacherEnterForm = (params: object = {}) => {
    //老师资料完善
    return request("post", "/api/teacher/enter_data", params);
};
//老师入驻流程end

// 获取安卓app下载地址
export const getConfigData = (params: object) => {
    return request("get", "/api/comm/on_off", params);
};

// 获取微信SDK签名
export const getWxConfig = (params: object) => {
    return request("get", "/api/comm/wx/jssdk", params);
};

// 获取灵机大师下载地址
export const getLjdsDownloadUrl = (params: object = {}) => {
    return request("get", "/v1/download/link", params);
};

// 双十一抽奖开始
// 抽奖信息
export const getLimited = (params: object = {}) => {
    return request("get", "/v1/limited", params);
};
// 获取抽奖结果
export const getLottery = (params: object = {}) => {
    return request("post", "/v1/limited/lottery", params);
};
// 每日分享
export const dayShare = (params: object = {}) => {
    return request("post", "/v1/limited/share", params);
};
// 关注老师
export const followTeacher = (params: object = {}) => {
    return request("post", "/v1/user/follow", params);
};
// 双十一抽奖结束

// 新人礼包v3，新人用户优惠券礼包是否已使用
export const getNewComerCouponStatus = (params: object = {}) => {
    return request("get", "/v1/user/newcomer/coupon_status", params);
};

// 新人礼包v3，新人用户直播打赏礼物道具礼包是否已使用
export const getNewComerLiveGiftStatus = (params: object = {}) => {
    return request("get", "/v1/user/newcomer/livegift_status", params);
};

// 获取老师电子签约信息
export const teacherSignInfo = (params: object = {}) => {
    return request("get", "/api/teacher/sign/info", params);
};

// 老师电子签约认证
export const teacherSignAuth = (params: object = {}) => {
    return request("post", "/api/teacher/sign/auth", params);
};

// 老师电子签约合同地址
export const teacherSignLink = (params: object = {}) => {
    return request("post", "/api/teacher/sign/start", params);
};

// 获取人脸认证链接
export const faceAuthLink = (params: object = {}) => {
    return request("get", "/api/teacher/get_face_auth_link", params);
};

// 检查是否人脸认证成功
export const checkSuccessFace = (params: object = {}) => {
    return request("get", "/api/teacher/check_success_face", params);
};

// 身份证认证
export const teacherIdCard = (params: object = {}) => {
    return request("post", "/api/teacher/ocr/idcard", params);
};

//2020app新年过的 start
//登录
export const loginPublicKey = (params: object = {}) => {
    return request("get", "/api/comm/setting", params);
};
export const loginSmsCode = (params: object = {}) => {
    return request("post", "/api/login/sms_code", params);
};
export const mobileLogin = (params: object = {}) => {
    return request("post", "/api/login/mobile", params);
};
//获取微信公共支付
export const getWxPublicPayUrl = (params: object = {}) => {
    return request("get", "/api/comm/on_off", params);
};
//获取审核key
export const getCommOnOff = (params: object = {}) => {
    return request("get", "/api/comm/on_off", params);
};
//获取任务列表
export const getTaskList = (params: object = {}) => {
    return request("get", "/api/newyear/2020/task/list", params);
};
//签到
export const toQiandao = (params: object = {}) => {
    return request("post", "/api/newyear/2020/sign", params);
};
//生成绕口令
export const getKouling = (params: object = {}) => {
    return request("get", "/api/password", params);
};
//元宝定价列表
export const getCoinFixlist = (params: object = {}) => {
    return request("get", "/api/newyear/2020/coin/fixlist", params);
};
//元宝下单
export const payCoinOrder = (params: object = {}) => {
    return request("post", "/api/order/coin/recharge", params);
};
//领取积分
export const lingquJifen = (params: object = {}) => {
    return request("post", "/api/newyear/2020/receive/integral", params);
};
//领取用户当前积分
export const getUserJifen = (params: object = {}) => {
    return request("get", "/api/newyear/2020/user/integral", params);
};
//积分奖品列表
export const getAwardList = (params: object = {}) => {
    return request("get", "/api/newyear/2020/integral/prize", params);
};
//兑换积分奖品
export const getAwardPresent = (params: object = {}) => {
    return request("post", "/api/newyear/2020/integral/prize", params);
};
//检查订单赠品
export const checkPresent = (params: object = {}) => {
    return request("get", "/api/newyear/2020/check/present", params);
};
//领取记录列表
export const getRecordList = (params: object = {}) => {
    return request("get", "/api/newyear/2020/receive/lists", params);
};

// 2020年度老师活动start
// 获取全部老师
export const getAllTeacher = (params: object = {}) => {
    return request("get", "/api/user_vote/teacher_rank", params);
};
// 获取已投老师
export const getVotedTeacher = (params: object = {}) => {
    return request("get", "/api/user_vote/voted_teacher", params);
};
// 获取消费过的老师
export const getConsumedTeacher = (params: object = {}) => {
    return request("get", "/api/user_vote/consumed_teacher", params);
};
// 获取粉丝排行榜
export const getFansList = (params: object = {}) => {
    return request("get", "/api/user_vote/user_rank", params);
};
// 获取老师排行榜详情
export const getTeacherVote = (params: object = {}) => {
    return request("get", "/api/user_vote/teacher_index", params);
};
// 获取用户投票详情
export const getUserVote = (params: object = {}) => {
    return request("get", "/api/user_vote/user_info", params);
};
// 用户签到
export const userSignIn = (params: object = {}) => {
    return request("post", "/api/user_vote/sign_in", params);
};
// 投票给老师
export const voteforTeacher = (params: object = {}) => {
    return request("post", "/api/user_vote/vote", params);
};
// 获取元宝数量
export const getUserCoin = (params: object = {}) => {
    return request("get", "/v1/user/coin", params);
};
// 打赏下单web端
export const rewardWeb = (params: object = {}) => {
    return request("post", "/api/order/reward", params);
};
// 打赏下单app端
export const rewardApp = (params: object = {}) => {
    return request("post", "/v1/order/reward", params);
};
// 消费元宝
export const coinConsume = (params: object = {}) => {
    return request("post", "/v1/user/coin/consume", params);
};
// 绑定手机号
export const mobileBind = (params: object = {}) => {
    return request("post", "/api/bind/query", params);
};
// 设备号检查，是否下载灵机APP
export const deviceCheck = (params: object = {}) => {
    return request("get", "/api/user/check/device", params);
};
// 2020年度老师活动end

//帮助中心start
export const problemList = (params: object = {}) => {
    //获取常见为题列表
    return request("get", "/api/helpcenter/problem/list", params);
};
export const serviceList = (params: object = {}) => {
    //获取服务须知列表
    return request("get", "/api/helpcenter/service/list", params);
};
export const serviceRules = (params: object = {}) => {
    //获取服务须知详情
    return request("get", "/api/helpcenter/service", params);
};
export const feedback = (params: object = {}) => {
    // 用户反馈接口
    return request("post", "/api/comm/feedback", params);
};
export const problem = (params: object = {}) => {
    // 常见问题详情
    return request("get", "/api/helpcenter/problem", params);
};
export const helpTips = (params: object = {}) => {
    // 常见问题详情
    return request("get", "/api/helpcenter/tips", params);
};

//新老师和知名大师
export const newTeacherList = (params: object = {}) => {
    return request("get", "/v1/wds/teacher/h5/new_settle_list", params);
};
export const famousTeacherList = (params: object = {}) => {
    return request("get", "/v1/wds/teacher/famous_list", params);
};
export const voiceTeacherList = (params: object = {}) => {
    return request("get", "/v1/voc/list", params);
};
export const newVoiceTeacherList = (params: object = {}) => {
    return request("get", "/v1/voc/h5/list", params);
};
export const qualityTeacherList = (params: object = {}) => {
    return request("get", "/v1/high/service/teacher/selected", params);
};
export const recVoiceTeacherList = (params: object = {}) => {
    return request("get", "/v1/voc/closet/connect", params);
};

// fm 分享页start
// 专辑详情
export const fmAlbumInfo = (params: object = {}) => {
    return request("get", "/v1/fm/album/info", params);
};
// 专辑音频歌词
export const fmAudioInfo = (params: object = {}) => {
    return request("get", "/v1/fm/audio/info", params);
};
// 专辑音频弹幕评论
export const fmAudioCommentList = (params: object = {}) => {
    return request("get", "/v1/fm/audio/comment/list", params);
};
// 专辑评论
export const fmAlbumCommentList = (params: object = {}) => {
    return request("get", "/v1/fm/album/comment/list", params);
};
// 用户详情
export const userDetail = (params: object = {}) => {
    return request("get", "/v2/user/detail", params);
};
// 感情专题对应的专题
export const freechatMaritalStatusTopic = (params: object = {}) => {
    return request("get", "/v1/freechat/marital_status/topic", params);
};
// fm 分享页end

// 运势start
// 获取运势详情
export const getYunshiDaily = (params: object = {}) => {
    return request("get", "/v1/user/yunshi/daily", params);
};
export const getUserPublicMsg = (params: object = {}) => {
    return request("get", "/api/user/public_msg", params);
};
// 运势end

// 桃花需求start
//获取用户桃花数量
export const taohuaNumber = (params: object = {}) => {
    return request("get", "/v1/pb/user/number", params);
};
//获取直播
export const taohuaLiveList = (params: object = {}) => {
    return request("get", "/v1/pb/live/list", params);
};
//获取桃花活动任务奖励
export const rewardTaskList = (params: object = {}) => {
    return request("get", "/v1/pb/task/get", params);
};
// 领取活动奖品
export const receivePrize = (params: object = {}) => {
    return request("get", "/v1/pb/receive/prize", params);
};
// 摘桃花
export const receiveTaohua = (params: object = {}) => {
    return request("get", "/v1/pb/activity/get_flowers", params);
};
// 我的活动奖品
export const myRewardList = (params: object = {}) => {
    return request("get", "/v1/pb/me/prize", params);
};
// 用户是否领了新人桃花礼
export const newComer = (params: object = {}) => {
    return request("get", "/v1/pb/user/new_comer/tag_pop", params);
};
// 桃花活动用户排行榜
export const taohuaRankList = (params: object = {}) => {
    return request("get", "/v1/pb/user/leaderboard", params);
};
// 桃花活动H5滚动
export const taohuaScroll = (params: object = {}) => {
    return request("get", "/v1/pb/user/scroll", params);
};
// 前三名是否弹窗
export const getIsPpop = (params: object = {}) => {
    return request("get", "/v1/pb/user/receive_status", params);
};
// 桃花需求end

//会员需求start
//权益列表
export const equityList = (params: object = {}) => {
    return request("get", "/v1/vip/privileges", params);
};
//权益列表
export const getUserVipInfo = (params: object = {}) => {
    return request("get", "/v2/vip/profile", params);
};
//升级福利列表
export const welfare = (params: object = {}) => {
    return request("get", "/v1/vip/welfare", params);
};
//会员页福利领取
export const receiveWelfare = (params: object = {}) => {
    return request("get", "/v1/vip/welfare/receive", params);
};
//我的会员页精选老师推荐列表
export const recomVipTeacher = (params: object = {}) => {
    return request("get", "/v1/high/service/lists", params);
};
//我的会员页精选老师通话老师列表
export const recomVipLink = (params: object = {}) => {
    return request("get", "/v1/voc/list", params);
};
//我的会员页页是否首次弹窗  显示红点
export const vipIsPop = (params: object = {}) => {
    return request("get", "/v1/vip/popup", params);
};
//我的会员页页是否首次弹窗 弹窗后  清除红点
export const vipClearPop = (params: object = {}) => {
    return request("get", "/v1/vip/popup/view", params);
};
//我的会员页页清除新的标志
export const claerNew = (params: object = {}) => {
    return request("get", "/v1/vip/privilege/info", params);
};
//获取会员生日信息
export const getVipBirth = (params: object = {}) => {
    return request("get", "/v1/user/information", params);
};
//修改会员生日信息
export const vipBirth = (params: object = {}) => {
    return request("post", "/v1/vip/birthday", params);
};
//我的权益获取提问老师
export const vipTeachers = (params: object = {}) => {
    return request("get", "/v1/teacher/lists", params);
};
//用户生日礼物的领取列表
export const vipCsRecord = (params: object = {}) => {
    return request("get", "/v1/vip/birthday/history", params);
};

//会员需求end

// 课程start
// 课程类目
export const courseCategory = (params: object = {}) => {
    return request("get", "/api/teacher/course/category", params);
};
// 课程列表
export const courseList = (params: object = {}) => {
    return request("get", "/api/teacher/course/list", params);
};
// 章节列表
export const chapterList = (params: object = {}) => {
    return request("get", "/api/teacher/course/chapter/list", params);
};
// 章节学习
export const chapterLearn = (params: object = {}) => {
    return request("post", "/api/teacher/course/chapter/learn", params);
};
// 获取课程试题
export const examList = (params: object = {}) => {
    return request("get", "/api/teacher/course/exam/list", params);
};
// 课程试题回答
export const examResult = (params: object = {}) => {
    return request("post", "/api/teacher/course/exam", params);
};
// 课程end

// 知屿商城
// 知屿商城列表
export const integraltMallList = (params: object = {}) => {
    return request("get", "/api/integral/goods", { ...params });
};
//积分明细
export const integralMallDetail = (params: object = {}) => {
    return request("get", "/v1/integral/detail", { ...params });
};
//积分商品详情
export const getMallGoodsInfo = (params: any) => {
    return request("get", `/api/integral/goods/info`, {
        v: 2,
        ...params
    });
};
// 商品下单
export const orderMallGoods = (params: object = {}) => {
    return request("post", "/api/order/goods", { ...params });
};
// 积分商品兑换（非实体商品）
export const notGoodsExchange = (params: object = {}) => {
    return request("post", "/api/integral/goods/exchange", { ...params });
};
// 积分商品兑换记录
export const exchangeMallRecord = (params: object = {}) => {
    return request("get", "/api/integral/user/exchange/record", { ...params });
};
// 积分商品消费积分
export const integralConsume = (params: object = {}) => {
    return request("post", "/api/integral/consume", { ...params });
};

// 积分乐购start
// 积分商城列表
export const integraltList = (params: object = {}) => {
    return request("get", "/v1/integral/goods", params);
};
// 兑换商品
export const integralExchange = (params: object = {}) => {
    return request("post", "/v1/integral/exchange", params);
};
// 积分明细
export const integralDetail = (params: object = {}) => {
    return request("get", "/v1/integral/detail", params);
};
// 新增用户收货信息
export const userAddress = (params: object = {}) => {
    return request("post", "/v1/user/address", params);
};
//编辑用户收货信息
export const editAddress = (params: any) => {
    return request("post", `/v1/user/address/${params.id}`, params);
};

// 首页打赏
export const integralExplanation = (params: object = {}) => {
    return request("get", "/v1/integral/explanation", params);
};
// 用户收货信息列表
export const userAddressList = (params: object = {}) => {
    return request("get", "/v1/user/address", params);
};
// 用户地址列表
export const userList = (params: object = {}) => {
    return request("get", "/api/address/user/list", params);
};
//积分兑换查询是否支付成功
export const checkExchangeOrder = (params: any) => {
    return request("post", `/api/order/list`, params);
};
//取消兑换订单
export const cancelExchangeOrder = (params: any) => {
    return request("post", `/v1/order/cancel/${params.source}`, params);
};
//取消兑换订单
export const getGoodDetail = (params: any) => {
    return request("get", `/v1/integral/goods/${params.id}`, params);
};
//积分商场资源位
export const getBanner = (params: any) => {
    return request("get", `/v1/home/common/adv_resourse`, params);
};

// 积分乐购end

// 获取FM列表
export const getFmList = (params: any) => {
    return request("get", `/v1/fm/audio/list`, {});
};

//2020 520活动
//5月活动用户信息
export const get520userInfo = (params: any) => {
    return request("get", `/api/activity/five/userinfo`, params);
};
//5月活动兑换礼物
export const change520gift = (params: any) => {
    return request("post", `/api/activity/five/exchange`, params);
};
//5月活动签到
export const sign520 = (params: any) => {
    return request("post", `/api/activity/five/signin`, params);
};
// 社群模块start
// 获取粉丝群详情
export const getGroupDetail = (params: any) => {
    return request("get", `/v1/community/group/info`, params);
};
// 用户入粉丝群邀请函是否过期
export const inviteStatus = (params: any = {}) => {
    return request("get", `/v1/community/group/user/invitation`, params);
};
// 获取粉丝群成员列表
export const getGroupUsers = (params: any) => {
    return request("get", `/v1/community/group/users`, params);
};
// 粉丝群团特权
export const getGroupPrivilegeInfo = (params: any) => {
    return request("get", `/v1/community/group/privilege_info`, params);
};
// 直播打赏，用于加入粉丝群
export const liveReward = (params: any) => {
    return request("post", `/v1/order/live/reward`, params);
};
// 用户入粉丝群
export const groupAdd = (params: any) => {
    return request("post", `/v1/community/group/user/add`, params);
};
// 获取抽奖弹幕记录
export const getDrawNotice = (params: any = {}) => {
    return request("get", `/v1/community/get/draw_top_record`, params);
};
// 背包礼物抽奖转盘
export const drawTurntable = (params: any) => {
    return request("post", `/v1/community/backpack/draw_turntable`, params);
};
// 福利专区
export const groupWelfare = (params: any = {}) => {
    return request("get", `/v1/community/group/welfare`, params);
};
// 设置用户装饰挂件
export const setDecorate = (params: any) => {
    return request("post", `/v1/user/set_decorative_pendant`, params);
};
// 社群福利专区老师优惠券领取
export const groupCouponReceive = (params: any) => {
    return request(
        "post",
        `/v1/coupon/community_group/teacher_coupon/receive`,
        params
    );
};
// 社群模块end
//冥想start
//冥想首页
export const mingxiang = (params: any) => {
    return request("get", `/v1/warm_heart`, params);
};
//我的报告首页
export const mingxiangIndex = (params: any) => {
    return request("get", `/v1/warm_heart/report`, params);
};
//别人报告首页
export const otherIndex = (params: any) => {
    return request("get", `/v1/warm_heart/report/${params.uid}`, params);
};
//我的报告详情
export const mingxiangDetail = (params: any) => {
    return request(
        "get",
        `/v1/warm_heart/report/${params.module}/info`,
        params
    );
};
//别人得报告详情
export const otherDetail = (params: any) => {
    return request(
        "get",
        `/v1/warm_heart/report/${params.uid}/${params.module}/info`,
        params
    );
};
//我的记录
export const mingxiangRecord = (params: any) => {
    return request(
        "get",
        `/v1/warm_heart/report/${params.module}/record`,
        params
    );
};
//别人得记录
export const otehrRecord = (params: any) => {
    ///v1/warm_heart/report/{uid}/{module}/record
    return request(
        "get",
        `/v1/warm_heart/report/${params.uid}/${params.module}/record`,
        params
    );
};
//冥想排行榜
export const mingxiangRank = (params: any) => {
    return request("get", `/v1/warm_heart/ranking`, params);
};
//冥想end
//66周年庆活动start
export const znqCoinlist = (params: any) => {
    //6月活动元宝定价
    return request("get", `/v1/june/2020/coinlist`, params);
};
export const znqRecharge = (params: any) => {
    //6月活动元宝充值
    return request("post", `/v1/order/coin/recharge`, params);
};
export const znqPrizelist = (params: any) => {
    //6月活动奖品列表
    return request("get", `/v1/june/2020/prizelist`, params);
};
export const znqChangeprize = (params: any) => {
    //6月活动奖品兑换
    return request("post", `/v1/june/2020/exchange`, params);
};
export const znqCheckOrder = (params: any) => {
    //6月活动奖品列表
    return request("get", `/api/order/is_order_pay`, params);
};
//66周年庆活动end

// 新手分发，是否符合新人返利
export const getUserFuli = (params: object = {}) => {
    return request("get", "/api/user/is_fanli", params);
};
export const freeTaluoAsk = (params: object = {}) => {
    return request("get", "/api/tarot/free/question", params);
};

// 情感测评start
export const getEmotionSubject = (params: any = { id: 1 }) => {
    return request("get", `/v1/emotion/${params.id}/issue`, params);
};
export const getEmotionResult = (params: any = { id: 1 }) => {
    return request("post", `/v1/emotion/${params.id}/estimate`, params);
};
export const getEmotionUidResult = (params: any = { id: 1, uid: "" }) => {
    return request(
        "get",
        `/v1/emotion/${params.id}/result/${params.uid}`,
        params
    );
};
export const getEmotionUserResult = (params: any = { id: 1 }) => {
    return request("get", `/v1/emotion/${params.id}/result`, params);
};
export const getUserInfo = (params: any = {}) => {
    return request("get", `/api/user/info`, params);
};
export const createShorturl = (params: any = {}) => {
    return request("post", `/v1/wechat/mini_program/generate/shorturl`, params);
};
export const getEmotionStartInfo = (params: any = {}) => {
    return request("get", `/v1/emotion/start`, params);
};
// 情感测评end

// iOS企业包配置接口
export const getApplePlist = (params: any = {}) => {
    return request("get", `/v1/common/apple/plist/get`, params);
};

// 老带新活动start
export const getActivityNewInfo = (params: any = {}) => {
    return request("get", `/api/activity/new/info`, params);
};
export const getActivityNewShare = (params: any = {}) => {
    return request("get", `/api/activity/new/share`, params);
};
// 老带新活动end

// 老师等级变更日志
export const getRankRecord = (params: any = {}) => {
    return request("get", `/api/teacher/level/change_log`, params);
};

//咨询顾问分配逻辑
export const toConsultant = (params: any) => {
    return request("post", `/v1/sales/freechat`, params);
};

//新人礼包领取情况
export const newcomerReceiveInfo = (params: any) => {
    return request("get", `/v2/home/newcomer/receive_info`, params);
};
//新人礼包领取
export const newcomerReceive = (params: any) => {
    return request("post", `/v2/home/newcomer/receive`, params);
};
// 一元礼包领取情况
export const unitaryInfo = (params: any = {}) => {
    return request("get", `/v2/home/newcomer/gift`, params);
};
// 一元礼包下单
export const unitaryOrder = (params: any = {}) => {
    return request("post", `/v1/order/novicegift`, params);
};

//2020国庆需求start
export const getqgPoints = (params: any = {}) => {
    //获取点数值
    return request("get", `/v1/2020/zq/points`, params);
};
export const getqgGiftList = (params: any = {}) => {
    //奖品列表
    return request("get", `/v1/2020/zq/gift`, params);
};
export const getqgGiftDetail = (params: any = {}) => {
    //奖品详情
    return request("get", `/v1/2020/zq/gift/${params.id}`, params);
};
export const getqgJoinPrize = (params: any = {}) => {
    //抽奖报名
    return request("post", `/v1/2020/zq/lottery/join`, params);
};
export const getqgAddressPrize = (params: any = {}) => {
    //抽奖地址兑换
    return request("post", `/v1/2020/zq/lottery/receive/address`, params);
};
export const getqgChangePrize = (params: any = {}) => {
    //兑换奖品
    return request("post", `/v1/2020/zq/gift/receive`, params);
};
export const getqgPrizeHistory = (params: any = {}) => {
    //抽奖历史
    return request("get", `/v1/2020/zq/lottery/history`, params);
};
export const getqgBroadcast = (params: any = {}) => {
    //已兑换列表
    return request("get", `/v1/2020/zq/gift/broadcast`, params);
};
export const getqgUserRank = (params: any = {}) => {
    //用户排行榜
    return request("get", `/v1/2020/zq/user/ranking`, params);
};
export const qgUserLike = (params: any = {}) => {
    //用户点赞
    return request("post", `/v1/2020/zq/user/ranking/like`, params);
};
export const getqgTeaRank = (params: any = {}) => {
    //老师邀请排行榜
    return request("get", `/v1/2020/zq/teacher/ranking`, params);
};
export const qgTeaLike = (params: any = {}) => {
    //老师点赞
    return request("post", `/v1/2020/zq/teacher/ranking/like`, params);
};
export const getqgTask = (params: any = {}) => {
    //每日任务列表
    return request("get", `/v1/2020/zq/task`, params);
};
export const qgDoTask = (params: any = {}) => {
    //领取每日任务
    return request("post", `/v1/2020/zq/task/${params.action}`, params);
};
export const getqgLive = (params: any = {}) => {
    //获取随机直播间
    return request("get", `/v1/live/get_rand`, params);
};
export const getqgFM = (params: any = {}) => {
    //获取随机直播间
    return request("get", `/v1/2020/zq/fm`, params);
};
export const getqgKouling = (params: any = {}) => {
    //获取口令
    return request("get", `/v1/password`, params);
};
export const getgqUniqid = (params: any = {}) => {
    //获取答题唯一id
    return request("get", `/v1/2020/zq/uniqid`, params);
};
export const getgqIssue = (params: any = {}) => {
    //获取第一道题id
    return request("get", `/v1/2020/zq/first/issue`, params);
};
export const getgqIssueTips = (params: any = {}) => {
    //获取问题提示
    return request("get", `/v1/2020/zq/issue/${params.id}/tips`, params);
};
export const getgqAnswer = (params: any = {}) => {
    //答题并获取下一题的提示
    return request("post", `/v1/2020/zq/issue/${params.id}/answer`, params);
};
export const getgqAnswerOut = (params: any = {}) => {
    //超时答题并获取下一题的提示
    return request("post", `/v1/2020/zq/issue/${params.id}/timeout`, params);
};
export const getgqAnswerParse = (params: any = {}) => {
    //解析
    return request("get", `/v1/2020/zq/answer/parsing`, params);
};
export const getgqShare = (params: any = {}) => {
    //分享
    return request("get", `/v1/common/share`, params);
};
export const getgqPassword = (params: any = {}) => {
    //打开口令接口
    return request("post", `/v1/password/open`, params);
};
//2020国庆需求end

// 社群课程start
export const groupCourseDetail = (params: any = {}) => {
    return request("get", `/v1/community/course/info`, params);
};
export const groupCourseOrder = (params: any = {}) => {
    return request("post", `/v1/order/community_course/pay`, params);
};
export const exerciseList = (params: any = {}) => {
    return request("get", `/v1/community/course/my_exercise/list`, params);
};
export const exerciseDetail = (params: any = {}) => {
    return request("get", `/v1/community/course/exercise/info`, params);
};
export const exerciseExam = (params: any = {}) => {
    return request("post", `/v1/community/course/exercise/save`, params);
};
export const exerciseResult = (params: any = {}) => {
    return request("get", `/v1/community/course/exercise/result`, params);
};
export const surveyInfo = (params: any = {}) => {
    return request("get", `/v1/community/course/questionnaire/info`, params);
};
export const surveySubmit = (params: any = {}) => {
    return request("post", `/v1/community/course/questionnaire/save`, params);
};
export const teacherCourseList = (params: any = {}) => {
    return request("get", `/v1/community/course/recommend`, params);
};
export const surveyQuestionAnswer = (params: any = {}) => {
    return request("get", `/v1/community/course/question/user/result`, params);
};
export const exerciseAnswer = (params: any = {}) => {
    return request("get", `/v1/community/course/exercise/user/list`, params);
};
export const courseCouponReceive = (params: any = {}) => {
    return request("post", `/v1/coupon/receive`, params);
};
export const uploadExerciseCover = (params: any = {}) => {
    return request("post", `/v1/community/course/exercise/cover`, params);
};
export const courseGroupHistory = (params: any = {}) => {
    return request("get", `/v1/community/course/history/message`, params);
};

//老师资源池
// 老师资源池列表
export const resourcePoolList = (params: any = {}) => {
    return request("get", `/api/teacher/resource/pool/list`, params);
};
// 老师资源池详情
export const resourcePoolInfo = (params: any = {}) => {
    return request("get", `/api/teacher/resource/pool/info`, params);
};
// 老师资源池报名
export const resourcePoolApply = (params: any = {}) => {
    return request("post", `/api/teacher/resource/pool/apply`, params);
};
// 老师资源池报名记录
export const resourcePoolRecord = (params: any = {}) => {
    return request("get", `/api/teacher/resource/pool/record`, params);
};

// 社群课程end

// 高级服务详情
export const highServiceDetail = (params: any = {}) => {
    return request("get", `/api/teacher/service/info`, params);
};
// 高价服务详情
export const customServiceDetail = (params: any = {}) => {
    return request("get", `/v1/high/service/expensive/info`, params);
};
// 高价服务分类
export const customServiceCate = (params: any = {}) => {
    return request("get", `/v1/high/service/expensive/category`, params);
};
// 老师信息详情
export const teacherInfo = (params: any = {}) => {
    return request("get", `/api/teacher/info`, params);
};
// 获取老师高级服务价格
export const highServicePrice = (params: any = {}) => {
    return request("get", `/v1/high/service/price`, params);
};
// 高级服务下单
export const highServiceOrder = (params: any = {}) => {
    return request("post", `/v1/order/consultant`, params);
};
// 高级服务下单api
export const highServiceOrderApi = (params: any = {}) => {
    return request("post", `/api/order/consultant`, params);
};
// 获取老师高级服务分类
export const highServiceType = (params: any = {}) => {
    return request("get", `/api/teacher/service`, params);
};
// 获取老师用户评论
export const teacherEvaluate = (params: any = {}) => {
    return request("get", `/api/teacher/evaluate_list`, params);
};

// 推荐商品start
// 新增用户收货地址
export const addRecAddress = (params: object = {}) => {
    return request("post", "/api/address/user/add", params);
};
// 编辑用户收货地址
export const editRecAddress = (params: object = {}) => {
    return request("post", "/api/address/user/edit", params);
};
// 用户收货地址列表
export const recAddressList = (params: any = {}) => {
    return request("get", `/api/address/user/list`, params);
};
// 商品详情
export const recGoodsDetail = (params: any) => {
    return request("get", `/api/shop/goods/info`, params);
};
// 商品下单
export const recGoodsOrder = (params: object = {}) => {
    return request("post", "/api/order/goods", params);
};
// 推荐商品end

// 获取咨询报告详情
export const consultationReportInfo = (params: any = {}) => {
    return request("get", `/api/consultation/service/report/info`, params);
};

// 老师推荐入驻start
// 邀请入驻统计
export const inviteEnterStatistics = (params: any = {}) => {
    return request("get", `/api/teacher/invite_enter_statistics`, params);
};
// 邀请入驻记录
export const inviteEnterRecord = (params: any = {}) => {
    return request("get", `/api/teacher/invite_enter_record`, params);
};
// 手机登录
// export const mobileLogin = (params: any = {}) => {
// 	return request("post", `/api/login/mobile`, params);
// };
// 老师推荐入驻end

// new-vip start
// 会员信息
export const getVipProfile = (params: any = {}) => {
    return request("get", `/v2/vip/profile`, params);
};
// 权益列表
export const privilegesList = (params: any = {}) => {
    return request("get", `/v2/vip/privileges`, params);
};
// 领取福利
export const welfareReceive = (params: any = {}) => {
    return request("post", `/v2/vip/welfare/receive`, params);
};
// 会员等级信息
export const getlevelInfo = (params: any = {}) => {
    return request("get", `/v2/vip/level/${params.level}`, params);
};
// 推荐直播间(单个)
export const getRecommendLive = (params: any = {}) => {
    return request("get", `/v2/live/get_recommend`, params);
};
// 经验升级列表
export const getExpMap = (params: any = {}) => {
    return request("get", `/v2/vip/exp/map`, params);
};
// 经验明细
export const getExpDetail = (params: any = {}) => {
    return request("get", `/v2/vip/exp/detail`, params);
};
// 八字信息列表
export const getMessList = (params: any = {}) => {
    return request("get", `/v1/user/mess/list`, params);
};
// 首页新人礼包悬浮
export const newcomerGift = (params: any = {}) => {
    return request("get", `/v2/home/newcomer/gift/susp`, params);
};
// 用户任务列表
export const getVipTaskList = (params: any = {}) => {
    return request("get", `/v1/vip/task/list`, params);
};
// 福利详情
export const getGiftDetail = (params: any = {}) => {
    return request("get", `/v2/vip/gift_type/${params.gift_type}`, params);
};
// 社群列表
export const getGroupList = (params: any = {}) => {
    return request("get", `/v1/community/group/all_list`, params);
};
// new-vip end
// 新人礼包领取情况 （新版2.1.1）
export const newcomerReceiveInfoV2 = (params: any = {}) => {
    return request("get", `/v2/home/newcomer/receive_info/211`, params);
};
// 新人礼包领取 （新版2.1.1）
export const newcomerReceiveV2 = (params: any) => {
    return request("post", `/v2/home/newcomer/receive/211`, params);
};
// 新人礼包领取情况 （知屿273版本，20210521）
export const newcomerReceiveInfoV3 = (params: any = {}) => {
    return request("get", `/v2/home/newcomer/activity2/receive_info`, params);
};
// 新人礼包领取 （知屿273版本，20210521）
export const newcomerReceiveV3 = (params: any = {}) => {
    return request("post", `/v2/home/newcomer/activity2/receive`, params);
};

// 老师年度盛典-获取老师信息
export const getTeacherInfo = (params: any) => {
    return request("get", `/api/user_vote/teacher_index`, params);
};

// 投诉
export const userComplaint = (params: object = {}, options?: {}) => {
    return request("post", "/api/sc/feedback", params, options);
};

// 文章详情页面分享H5 start
// 获取文章详情
export const getArticleInfo = (params: any = {}) => {
    return request("get", `/v1/article/info`, params);
};
// 获取文章评论
export const getArticleComment = (params: any = {}) => {
    return request("get", `/v1/article/user/comment_list`, params);
};
// 获取文章推荐老师问题
export const getArticleAsk = (params: any = {}) => {
    return request("get", `/v2/popup/teacher/ask_options`, params);
};
// 文章详情页面分享H5 end

// 获取畅聊老师
export const getTeacherList = (params: object = {}, options?: {}) => {
    return request("get", "/api/free_chat/teacher_recommend", params, options);
};

// 搜索老师
export const searchTeacherList = (params: object = {}, options?: {}) => {
    return request("get", "/v1/search/teacher", params, options);
};

// 创建聊天室
export const createRoom = (params: object = {}, options?: {}) => {
    return request("post", "/api/free_chat/create_room", params, options);
};
// 签到（获取塔罗牌）
export const tarotSignIn = (params: object = {}, options?: {}) => {
    return request("post", "/v1/tarot/signin", params, options);
};

// 当天签到信息
export const getTarotSignIn = (params: object = {}, options?: {}) => {
    return request("get", "/v1/tarot/signin", params, options);
};

// 用户绑定塔罗牌
export const bindTarotSign = (params: object = {}, options?: {}) => {
    return request("post", "/v1/tarot/signin/bind", params, options);
};

// 获取老师直播能力值
export const getLiveAbility = (params: object = {}, options?: {}) => {
    return request("get", "/api/teacher/ability/live", params, options);
};

// 获取老师连线能力值
export const getVocAbility = (params: object = {}, options?: {}) => {
    return request("get", "/api/teacher/ability/voc", params, options);
};

// 获取老师咨询能力值
export const getConsultAbility = (params: object = {}, options?: {}) => {
    return request("get", "/api/teacher/ability/consultance", params, options);
};

// 获取付费聊天室聊天记录
export const chatroomHistory = (params: any = {}) => {
    return request("get", `/v1/consultant/history`, params);
};

// 优惠券专区
export const couponPre = (params: any = {}) => {
    return request("get", `/v1/coupon/area`, params);
};
// 领取老师专属优惠券
export const getTeacherCoupon = (params: object = {}, options?: {}) => {
    return request(
        "post",
        "/v1/coupon/teacher_coupon/receive",
        params,
        options
    );
};
// 领取老师专属优惠券成功气泡，发送到聊天室
export const couponBubble = (params: object = {}, options?: {}) => {
    return request("post", "/v1/coupon/send_bubble", params, options);
};

// 高级服务详情
export const getServiceInfo = (params: object = {}, options?: {}) => {
    return request("get", "/api/teacher/service/info", params, options);
};

// 获取用户实名认证信息
export const realNameInfo = (params: object = {}) => {
    return request("get", "/api/user/realyname_info", params);
};
// 用户实名认证
export const realNameAuth = (params: object = {}) => {
    return request("post", "/api/user/realyname_verification", params);
};

// 每日专题推荐
export const getDayRec = (params: object = {}) => {
    return request("get", "/v1/high/service/recommend/topic/day", params);
};

// 获取合盘详情
export const getPlateDetail = (params: object = {}) => {
    return request("get", "/v1/alloy/plate/detail", params);
};
// 获取用户装饰挂件
export const getDecorativePendant = (params: object = {}) => {
    return request("get", "/v1/user/get_decorative_pendant", params);
};

// 设置用户装饰挂件
export const setDecorativePendant = (params: object = {}) => {
    return request("post", "/v1/user/set_decorative_pendant", params);
};

// SVIP start

// SVIP 信息
export const svipInfo = (params: object = {}) => {
    return request("get", "/v1/svip/info", params);
};

// SVIP 下单
export const svipOrder = (params: object = {}) => {
    return request("post", "/v1/order/svip/pay", params);
};

// SVIP 权益详情
export const privilegesGift = (params: object = {}) => {
    return request("get", "/v1/svip/privileges_gift", params);
};

// SVIP 领取权益
export const privilegesReceive = (params: object = {}) => {
    return request("post", "/v1/svip/privileges_welfare_svip_receive", params);
};

// SVIP 老师语音连线列表(H5)
export const vocList = (params: object = {}) => {
    return request("get", "/v1/voc/h5/list", params);
};

// SVIP 一级服务分类列表
export const categoryList = (params: object = {}) => {
    return request("get", "/v1/high/service/get/category/list", params);
};

// SVIP 服务领域分类老师列表
export const areaServiceList = (params: object = {}) => {
    return request("get", "/v1/high/service/area/teacher", params);
};

// 根据订单号获取支付链接
export const getPayUrlByOrderId = (params: object = {}) => {
    return request("get", "/api/comm/pay/url", params);
};

// 获取剩余免费连线时间
export const getVocFreeTime = (params: object = {}) => {
    return request("get", "/v1/voc/free_time", params);
};

// 老师成长任务
export const teacherTask = (params: object = {}) => {
    return request("get", "/api/teacher/teacher_task", params);
};
// 用户账号注销
export const userCancel = (params: object = {}) => {
    return request("get", "/v1/common/user/cancel", params);
};
// 派发优惠券接口
export const sendCoupons = (params: object = {}) => {
    return request("post", "/api/teacher/send_coupons", params);
};
// 老师优惠券列表
export const couponsList = (params: object = {}) => {
    return request("get", "/api/teacher/coupons_list", params);
};
// 老师发布过心得的商品
export const userExperienceGoods = (params: object = {}) => {
    return request("get", "/api/user/user_experience_goods", params);
};
// 推荐过的商品列表
export const goodsRecommended = (params: object = {}) => {
    return request("get", "/api/shop/goods/recommended", params);
};
// 搜索商品列表
export const goodsSearch = (params: object = {}) => {
    return request("get", "/api/shop/goods/search", params);
};
// 首页类目
export const shopCategory = (params: object = {}) => {
    return request("get", "/api/shop/category", params);
};
// 推荐商品
export const sendGoods = (params: object = {}) => {
    return request("post", "/api/shop/goods/send_goods", params);
};
// 问卷调查
export const askAnswerSubject = (params: object = {}) => {
    return request("get", "/api/teacher/ask_answer/subject", params);
};
// 提交问卷调查答案
export const askAnswerReply = (params: object = {}) => {
    return request("post", "/api/teacher/ask_answer/reply", params);
};
// 完成vip日常任务
export const completeTask = (params: object = {}) => {
    return request("post", "/v2/vip/complete/task", params);
};
// 星座列表
export const constellationList = (params: object = {}) => {
    return request("get", `${isSandbox() ? 'https://sandbox-app-api.yiqiwen.cn' : 'https://app-api.yiqiwen.cn'}/constellation/list`, params);
};
// 星座运势
export const constellationDetail = (params: object = {}) => {
    return request("post", `${isSandbox() ? 'https://sandbox-app-api.yiqiwen.cn' : 'https://app-api.yiqiwen.cn'}/constellation/yunshi`, params);
};

// 档案添加/编辑(type	1新增，2编辑)
export const archivesAdd = (params: object = {}, type = 1) => {
    return request("post", `${isSandbox() ? 'https://sandbox-app-api.yiqiwen.cn' : 'https://app-api.yiqiwen.cn'}/constellation/me/archives/add/${type}`, params);
};

// 档案合盘
export const archivesAlloyPlate = (params: object = {}) => {
    return request("post", `/v1/alloy/archives/alloy_plate`, params);
};

// 年度盛典入口
export const getNdlsEntrance = (params = {}) => {
    return request("get", '/v2/home/adv/star_teacher', params);
};

// 服务详细页过滤微信或支付宝支付
export function getFilterPayment(): Promise<{ is_show: boolean }> {
    return request("get", '/v1/order/serve/filter_payment', {}) as any;
};
export const poolTeacher = (params = {}) =>{
    return request("get", '/api/teacher/pool/teacher',params) as any;
};
export const getSvipPayList = (params = {}) =>{
    return request("get", '/v1/svip/pay_list',params) as any;
};
export const getSvipH5Info = (params = {}) =>{
    return request("get", '/v1/svip/h5_info',params) as any;
};
// 首页助理icon
export const getHomeAssistantIcon = (params = {}) =>{
    return request("get", '/v1/assistant_chat_room/home_assistant_icon',params) as any;
};


